import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-048ddf59")

_pushScopeId("data-v-048ddf59")
const _hoisted_1 = { class: "icon-card " }
const _hoisted_2 = { class: "icon-card-main" }
const _hoisted_3 = { class: "icon-contain" }
const _hoisted_4 = { class: "width105px" }
const _hoisted_5 = { class: "flex1 padding-top15px padding-left30px" }
const _hoisted_6 = { class: "primary" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("img", {
            src: _ctx.cardData.icon
          }, null, 8, ["src"])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("p", _hoisted_6, _toDisplayString(_ctx.text), 1),
          _createVNode("b", null, _toDisplayString(_ctx.title), 1)
        ])
      ])
    ])
  ]))
})